export const getYoutubeVideoId = (url?: string) => {
  if (!url?.includes('www.youtube.com')) {
    return '';
  }

  return new URLSearchParams(new URL(url).search).get('v') ?? '';
};
